// src/pages/ContactPage.jsx
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Layout from "../components/Layout";
import Card from "../components/Card";
import Button from "../components/Button";
import { Box, TextField, Typography } from "@mui/material";
import { contactus } from "../services/ContactService";
import "./ContactPage.css";
import PageHeader from '../components/PageHeader';

const ContactPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    if (!email || !subject || !message) {
      setError(t("contact.errorEmpty"));
      return;
    }

    const emailRegex = /\S+@\S+\.\S+/;
    if (!emailRegex.test(email)) {
      setError(t("contact.errorInvalidEmail"));
      return;
    }

    try {
      setLoading(true);
      await contactus(email, subject, message);
      setSuccess(t("contact.success"));
      setEmail("");
      setSubject("");
      setMessage("");
    } catch (err) {
      setError("Erreur: " + err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout>
      <PageHeader 
        title={t("contact.title")} 
        subtitle={t("contact.subtitle")} 
      />
      <Card title={t("contact.cardTitle")}>
        <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
          <TextField
            label={t("contact.emailLabel")}
            variant="outlined"
            fullWidth
            margin="normal"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            sx={{ "& .MuiOutlinedInput-root": { borderRadius: "16px" } }}
          />
          <TextField
            label={t("contact.subjectLabel")}
            variant="outlined"
            fullWidth
            margin="normal"
            value={subject}
            onChange={(e) => setSubject(e.target.value)}
            required
            sx={{ "& .MuiOutlinedInput-root": { borderRadius: "16px" } }}
          />
          <TextField
            label={t("contact.messageLabel")}
            variant="outlined"
            fullWidth
            margin="normal"
            multiline
            rows={5}
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            required
            sx={{ "& .MuiOutlinedInput-root": { borderRadius: "16px" } }}
            InputLabelProps={{ shrink: true }}
          />
          <div style={{ textAlign: "center", marginTop: "1.5rem" }}>
            <Button 
              label={loading ? t("contact.loading") : t("contact.submitButton")} 
              onClick={handleSubmit} 
              disabled={loading} 
              type="submit"
            />
          </div>
          {error && (
            <Typography color="error" variant="body2" align="center" sx={{ mt: 1 }}>
              {error}
            </Typography>
          )}
          {success && (
            <Typography color="success" variant="body2" align="center" sx={{ mt: 1 }}>
              {success}
            </Typography>
          )}
        </Box>
      </Card>
    </Layout>
  );
};

export default ContactPage;
